import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400&family=Playfair+Display:wght@400;500;600;700&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .fp-root {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'DM Sans', sans-serif;
    background: #f7f5ff;
    padding: 24px;
    position: relative;
    overflow: hidden;
  }
  .fp-root::before {
    content: '';
    position: absolute; inset: 0;
    background:
      radial-gradient(ellipse 340px 240px at 95% 5%,  rgba(168,85,247,0.10) 0%, transparent 70%),
      radial-gradient(ellipse 300px 300px at 5%  95%, rgba(109,40,217,0.08) 0%, transparent 70%);
    pointer-events: none;
  }

  .fp-card {
    width: 420px;
    max-width: 100%;
    background: #ffffff;
    border-radius: 24px;
    box-shadow: 0 24px 70px rgba(76,29,149,0.16);
    padding: 40px;
    position: relative;
    z-index: 1;
  }

  .fp-icon-circle {
    width: 58px; height: 58px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(109,40,217,0.12), rgba(168,85,247,0.12));
    border: 1px solid rgba(168,85,247,0.25);
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 20px;
  }

  .fp-heading {
    font-family: 'Playfair Display', serif;
    font-size: 30px; font-weight: 700;
    color: #1f1035; text-align: center;
    letter-spacing: -0.5px; margin-bottom: 10px;
  }
  .fp-subhead {
    font-size: 13.5px; color: #4C1D95;
    text-align: center; font-weight: 400;
    line-height: 1.6; opacity: 0.75;
    margin-bottom: 28px;
  }

  .fp-alert {
    width: 100%; padding: 11px 15px; border-radius: 12px;
    font-size: 13px; font-weight: 500;
    display: flex; align-items: center; gap: 8px; margin-bottom: 20px;
    line-height: 1.5; word-break: break-word;
  }
  .fp-alert.error   { background: #fff4f4; color: #b83030; border: 1px solid rgba(184,48,48,0.15); }
  .fp-alert.success { background: #f0fdf4; color: #15803d; border: 1px solid rgba(21,128,61,0.18); }

  .fp-field { width: 100%; margin-bottom: 18px; }
  .fp-label {
    display: block; font-size: 11px; font-weight: 700;
    color: #4C1D95; letter-spacing: 2px;
    text-transform: uppercase; margin-bottom: 8px;
  }
  .fp-input-wrap {
    position: relative; display: flex; align-items: center;
    background: #f5f3ff; border: 1.5px solid #DDD6FE;
    border-radius: 13px; padding: 0 14px;
    transition: all 0.22s ease;
  }
  .fp-input-wrap:focus-within {
    border-color: #6D28D9; background: #ffffff;
    box-shadow: 0 0 0 4px rgba(109,40,217,0.1), 0 4px 16px rgba(109,40,217,0.08);
  }
  .fp-input {
    flex: 1; padding: 14px 0; border: none;
    background: transparent; color: #1f1035;
    font-size: 14px; font-family: 'DM Sans', sans-serif;
    font-weight: 400; outline: none; letter-spacing: 0.1px;
  }
  .fp-input::placeholder { color: #C4B5FD; font-weight: 300; }

  .fp-eye-btn {
    background: none; border: none; cursor: pointer;
    padding: 4px 2px; color: #A78BFA; font-weight: 600;
    font-size: 12.5px; font-family: 'DM Sans', sans-serif;
    letter-spacing: 0.5px; transition: color 0.18s; flex-shrink: 0;
  }
  .fp-eye-btn:hover { color: #6D28D9; }

  .fp-password-strength {
    margin-top: 8px; height: 4px;
    background: #EDE9FE; border-radius: 2px; overflow: hidden;
  }
  .fp-password-strength-bar {
    height: 100%;
    transition: width 0.3s, background-color 0.3s;
  }
  .fp-password-strength-bar.weak   { width: 33%;  background-color: #e05252; }
  .fp-password-strength-bar.medium { width: 66%;  background-color: #f0ad4e; }
  .fp-password-strength-bar.strong { width: 100%; background-color: #10B981; }
  .fp-note { margin-top: 8px; color: #7c6a9c; font-size: 12px; }

  .fp-btn {
    width: 100%; padding: 15px;
    background: linear-gradient(135deg, #6D28D9 0%, #A855F7 100%);
    border: none; border-radius: 13px;
    color: white; font-weight: 600; font-size: 14px;
    font-family: 'DM Sans', sans-serif;
    cursor: pointer; letter-spacing: 1.8px; text-transform: uppercase;
    position: relative; overflow: hidden;
    transition: transform 0.18s, box-shadow 0.18s, opacity 0.18s;
    box-shadow: 0 10px 32px rgba(109,40,217,0.38);
    margin-top: 6px;
  }
  .fp-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 16px 44px rgba(109,40,217,0.52);
  }
  .fp-btn:active:not(:disabled) { transform: translateY(0); }
  .fp-btn:disabled { opacity: 0.62; cursor: not-allowed; }
  .fp-btn::after {
    content: ''; position: absolute; top: 0; left: -100%;
    width: 60%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: left 0.5s;
  }
  .fp-btn:hover::after { left: 160%; }
  .fp-btn-inner {
    display: flex; align-items: center;
    justify-content: center; gap: 10px; position: relative; z-index: 1;
  }
  .fp-spinner {
    width: 16px; height: 16px;
    border: 2.5px solid rgba(255,255,255,0.3);
    border-top-color: white; border-radius: 50%;
    animation: spin 0.7s linear infinite; flex-shrink: 0;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  .fp-footer {
    margin-top: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    color: #4C1D95;
    padding-top: 20px;
    border-top: 1px solid #EDE9FE;
  }
  .fp-footer a {
    color: #6D28D9; text-decoration: none;
    font-weight: 600; cursor: pointer; transition: color 0.15s;
  }
  .fp-footer a:hover { color: #4C1D95; }

  @media (max-width: 480px) {
    .fp-card { padding: 30px 24px; }
    .fp-heading { font-size: 26px; }
  }
`;

const BASE_URL = "https://study.richmindx.in";

// ── Extract the full token from the URL path, safely handling JWT/hash dots ──
const extractTokenFromURL = () => {
  const pathname = window.location.pathname;
  const match = pathname.match(/\/reset-password\/(.+)/);
  if (match && match[1]) return match[1];
  return null;
};

// ── Try both endpoint patterns your backend might use ──
const resetPasswordAPI = async (token, newPassword) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/api/admin/reset-password`,
      { token, newPassword },
      { headers: { "Content-Type": "application/json" }, timeout: 15000 }
    );
    return res;
  } catch (errA) {
    if (!errA.response || errA.response.status !== 404) throw errA;
  }

  const res = await axios.post(
    `${BASE_URL}/api/admin/reset-password/${encodeURIComponent(token)}`,
    { newPassword },
    { headers: { "Content-Type": "application/json" }, timeout: 15000 }
  );
  return res;
};

const ResetPassword = () => {
  const navigate = useNavigate();

  const [token] = useState(() => extractTokenFromURL());
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [msg, setMsg] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(false);
  const [tokenValid, setTokenValid] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");

  useEffect(() => {
    if (!token) {
      setMsg({ type: "error", text: "Invalid reset link. No token found." });
      setTokenValid(false);
      return;
    }
    setTokenValid(true);
  }, [token]);

  useEffect(() => {
    if (!newPassword) { setPasswordStrength(""); return; }
    let strength = 0;
    if (newPassword.length >= 8) strength++;
    if (/[A-Z]/.test(newPassword)) strength++;
    if (/[0-9]/.test(newPassword)) strength++;
    if (/[^A-Za-z0-9]/.test(newPassword)) strength++;
    if (strength < 2) setPasswordStrength("weak");
    else if (strength < 4) setPasswordStrength("medium");
    else setPasswordStrength("strong");
  }, [newPassword]);

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      setMsg({ type: "error", text: "Please fill in both password fields." });
      return;
    }
    if (newPassword.length < 8) {
      setMsg({ type: "error", text: "Password must be at least 8 characters long." });
      return;
    }
    if (newPassword !== confirmPassword) {
      setMsg({ type: "error", text: "Passwords do not match." });
      return;
    }
    if (!token) {
      setMsg({ type: "error", text: "Reset token is missing. Please use the link from your email." });
      return;
    }

    try {
      setLoading(true);
      setMsg({ type: "", text: "" });

      const res = await resetPasswordAPI(token, newPassword);

      setMsg({
        type: "success",
        text: res.data.message || "Password reset successfully! Redirecting to login…",
      });

      setTimeout(() => navigate("/admin/login"), 2000);
    } catch (error) {
      let backendMsg;

      if (!error.response) {
        backendMsg = "Cannot connect to the server. Make sure the backend is running on port 5000.";
      } else {
        switch (error.response.status) {
          case 400:
            backendMsg =
              error.response.data?.message ||
              error.response.data?.error ||
              "Invalid or expired reset token. Please request a new password reset link.";
            break;
          case 401:
            backendMsg = "Reset token is invalid or has expired. Please request a new link.";
            break;
          case 404:
            backendMsg =
              "Reset endpoint not found on the server. Please check your backend routes.";
            break;
          case 500:
            backendMsg =
              error.response.data?.message ||
              "Server error while resetting password. Please try again later.";
            break;
          default:
            backendMsg =
              error.response.data?.message ||
              error.response.data?.error ||
              `Unexpected error (${error.response.status}). Please try again.`;
        }
      }

      setMsg({ type: "error", text: backendMsg });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => { if (e.key === "Enter") handleResetPassword(); };

  // ── Token checking state ──
  if (tokenValid === null) {
    return (
      <>
        <style>{CSS}</style>
        <div className="fp-root">
          <div className="fp-card" style={{ textAlign: "center" }}>
            <span className="fp-spinner" style={{ borderTopColor: "#6D28D9", borderColor: "rgba(109,40,217,0.2)", width: 26, height: 26, margin: "0 auto", display: "inline-block" }} />
            <p style={{ marginTop: 16, color: "#4C1D95" }}>Loading reset form…</p>
          </div>
        </div>
      </>
    );
  }

  // ── Invalid token ──
  if (!tokenValid) {
    return (
      <>
        <style>{CSS}</style>
        <div className="fp-root">
          <div className="fp-card">
            <div className="fp-heading">Reset Link Expired</div>
            <div className="fp-alert error" style={{ marginTop: 12 }}>
              This reset link is invalid or has expired. Please request a new one.
            </div>
            <button className="fp-btn" onClick={() => navigate("/admin/forgot-password")}>
              <span className="fp-btn-inner">Request New Reset Link</span>
            </button>
          </div>
        </div>
      </>
    );
  }

  // ── Main reset form ──
  return (
    <>
      <style>{CSS}</style>
      <div className="fp-root">
        <div className="fp-card">
          <div className="fp-icon-circle">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6D28D9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" />
              <path d="M7 11V7a5 5 0 0110 0v4" />
            </svg>
          </div>

          <div className="fp-heading">Reset Password</div>
          <div className="fp-subhead">
            Enter your new password below to regain access to your account.
          </div>

          {msg.text && <div className={`fp-alert ${msg.type}`}>{msg.text}</div>}

          <div className="fp-field">
            <label className="fp-label">New Password</label>
            <div className="fp-input-wrap">
              <input
                type={showPassword ? "text" : "password"}
                className="fp-input"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button type="button" className="fp-eye-btn" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
            {newPassword && (
              <>
                <div className="fp-password-strength">
                  <div className={`fp-password-strength-bar ${passwordStrength}`} />
                </div>
                <div className="fp-note">
                  Password strength: <strong>{passwordStrength}</strong>
                </div>
              </>
            )}
          </div>

          <div className="fp-field">
            <label className="fp-label">Confirm Password</label>
            <div className="fp-input-wrap">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="fp-input"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button type="button" className="fp-eye-btn" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <button
            className="fp-btn"
            type="button"
            onClick={handleResetPassword}
            disabled={loading || !newPassword || !confirmPassword}
          >
            <span className="fp-btn-inner">
              {loading ? (
                <><span className="fp-spinner" /> Resetting…</>
              ) : (
                "Reset Password"
              )}
            </span>
          </button>

          <div className="fp-footer">
            <span>Know your password?</span>
            <a onClick={() => navigate("/admin/login")}>Back to login</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;